import { Reato } from '../../../models/reato';
export class ReatoAdapter {

  reato: Reato = new Reato();

constructor(reato: Reato) {
  this.reato.id = reato.id ;
  this.reato.datiReato = reato.datiReato;
  this.reato.controparte = reato.controparte;
};

}
